export var AmountItemType;
(function (AmountItemType) {
    AmountItemType[AmountItemType["Undefined"] = 0] = "Undefined";
    AmountItemType[AmountItemType["Planned"] = 1] = "Planned";
    AmountItemType[AmountItemType["Realized"] = 2] = "Realized";
    AmountItemType[AmountItemType["Difference"] = 3] = "Difference";
    AmountItemType[AmountItemType["Total"] = 4] = "Total";
    AmountItemType[AmountItemType["Estimate"] = 5] = "Estimate";
})(AmountItemType || (AmountItemType = {}));
